
const ROUTE_REGEX = /(.{2})(.{2})(.{2})(.*)/;
const CLEAR_REGEX = /[.,]+/g;
const SP_REGEX = /\s+/g;
const DIA_REGEX = /[\u0300-\u036f]/g;

const TOKEN = import.meta.env.VITE_TOKEN;
const ITEMS_EP = import.meta.env.VITE_ITEMS_EP;

// Lista de metadatos
const mdnames = {
    'ncd_categorytype': 'Tipo de colección',
    'dw_type': 'Tipo de recurso digital',
    'dc_publisher_country': 'País de publicación',
    'ncd_parentinnstitutionname': 'Nombre de la Institución',
    'ncd_institutionname': 'Entidad',
    'ncd_departament': 'Departamento',
    'ncd_parentcollectionname': 'Nombre de la colección principal',
    'ncd_collectionName': 'Nombre de la colección',
    'ncd_alternativeName': 'Nombre alternativo de la colección',
    'ncd_maincollectionresponsible': 'Responsables de la colección',
    'ncd_collectionresponsible': 'Responsables de la colección principal',
    'ncd_institutioncode': 'Código o acrónimo de la Institución',
    'ncd_collectioncode': 'Código o acrónimo de la colección',
    'dc_audience_level': 'Nivel educativo',
    'dc_audience': 'Audiencia',
    'dc_description_sponsorship': 'Patrocinio',
    'dc_rights_accessrights': 'Derechos de acceso',
    'dc_rights_holder': 'Propietario de los derechos de autor',
    'dc_rights_license': 'Licencia Creative Commons',
    'dc_provenance': 'Procedencia',
    'dc_provenance_credits': 'Créditos de la colección',
    'ncd_contactInformation': 'Contacto de la colección',
    'dc_subject': 'Tema',
    'dc_subject_microscopetype': 'Tipo de microscopía',
    'dc_subject_microscope': 'Microscopio',
    'dc_subject_techniquetype': 'Tipo de técnica',
    'dc_subject_technique': 'Técnica',
    'dc_creator_preparation': 'Autor de la preservación',
    'dc_description_thickness': 'Espesor del corte',
    'dc_description_orientation': 'Referencia de corte',
    'dc_description_cut': 'Descripción del corte',
    'dc_identifier_guid': 'Identificador único del recurso',
    'dc_identifier_local': 'Identificador local',
    'dc_title': 'Título',
    'dc_description_keyword': 'Palabras clave',
    'dc_type': 'Tipo de recurso',
    'dc_format_extent': 'Extensión',
    'dc_description': 'Descripción de la imagen',
    'dc_identifier_doi': 'Identificador de imagen',
    'dc_creator': 'Autor de la imagen',
    'dc_date_created': 'Fecha de creación de la imagen',
    'dc_description_magnification': 'Aumento',
    'dw_kingdom': 'Reino',
    'dw_phylum': 'Phylum',
    'dw_class': 'Clase',
    'dw_order': 'Orden',
    'dw_family': 'Familia',
    'dw_scientificname': 'Nombre científico del organismo o microorganismo',
    'dw_scientificname_host': 'Nombre científico del hospedero',
    'dw_vernacularname': 'Nombre común del organismo o microorganismo',
    'dw_vernacularame_host': 'Nombre común del hospedero',
    'dc_description_organismbreed': 'Raza del organismo',
    'dc_description_organismsex': 'Sexo del organismo',
    'dc_description_organismage': 'Edad del organismo',
    'dc_creator_diagnosis': 'Autor del diagnóstico',
    'dc_date_diagnosis': 'Fecha de diagnóstico',
    'dc_description_disease': 'Enfermedad',
    'dc_description_diagnosis': 'Diagnóstico',
    'dc_description_injurytype': 'Tipo de lesión',
    'dc_description_etiology': 'Etiología',
    'dw_country': 'País',
    'dw_stateprovince': 'Estado o provincia',
    'dw_county': 'Municipio',
    'dw_locality': 'Localidad',
    'dc_subject_system': 'Sistema',
    'dc_subject_organ': 'Órgano',
    'dc_subject_tissue': 'Tejido',
    'dc_identifier_bibliographiccitation': 'Referencia bibliográfica',
    'dc_date_issued': 'Fecha de publicación',
    'dc_date_available': 'Fecha de disponibilidad',
    'dc_date_modified': 'Fecha de última modificación',
    'dc_description_repository': 'Nombre del repositorio',
    'dc_description_methodofinstruction': 'Método de instrucción',
}

// Metadatos sobre los que se hace el query de la barra de búsqueda
const mdsearch = [
    'metadata.dc_title',
    'metadata.dw_vernacularname',
    'metadata.dc_description_keyword',
    'metadata.dw_scientificname',
    'metadata.dc_description_disease',
    'metadata.dc_description_diagnosis',
    'metadata.dc_description_injurytype',
    'metadata.dc_subject_organ',
    'metadata.dc_creator',
    'metadata.ncd_departament',
    'metadata.ncd_parentinstitutionname',
    'metadata.ncd_institutionname',
    'metadata.ncd_departament',
    'metadata.ncd_maincollectionresponsible',
]

// Metadatos que se precargan y pueden aparecer en las cartas de los resultados de busqueda
export const cardfields = [
    'metadata.dc_title',
    'metadata.dc_description_keyword',
    'metadata.dw_scientificname',
    'metadata.dw_vernacularname',
    'metadata.dc_description_disease',
    'metadata.dc_description_diagnosis',
    'metadata.dc_description_injurytype',
    'metadata.dc_subject_organ',
    'metadata.dc_subject',
    'metadata.dw_scientificname',
    'metadata.dw_vernacularname',
    'metadata.dc_subject_microscopetype',
    'metadata.dc_subject_techniquetype',
    'metadata.dc_subject_technique',
    'metadata.dc_creator',
    'metadata.ncd_departament',
    'metadata.ncd_parentinstitutionname',
    'metadata.dc_audience',
    'metadata.dc_audience_level',
    'metadata.dc_rights_accessrights',
    'metadata.dc_rights_holder',
    'metadata.ncd_collectionName',
    'metadata.ncd_maincollectionresponsible',
    'metadata.dc_identifier_other',
    'source.iipImageServer',
]

// Actualmente, solo los valores de los filtros por tema. TODO: expandir filtros
export const fixedValues = {
    'dc_subject': [
        'Embriología',
        // 'Estudio de enfermedades',
        // 'Estudio de organismo',
        'Histología',
        'Parasitología',
        'Patología',
        // 'Tipos de células',
        // 'Tipos de lesión',
        'Bacteriología',
        'Micología',
    ]
}

export const doc2Item = (doc) =>{
    let item = { metadata: { }};
    item.id = doc._id;
    item.source = doc._source.source;
    let entries = Object.entries(doc._source.metadata);
    entries.forEach(([key, val]) => {
        item.metadata[key] = {
            value: val.join(', '),
            name: mdnames[key]
        }
    });
    itemIIP(item);
    return item;
}

export const hit2Item = (hit) => {
    let item = { metadata: { }, source: {}};
    item.id = hit._id;
    let entries = Object.entries(hit.fields);


    let key;
    entries.forEach(([k, val]) => {
        if (k.startsWith('metadata')) {
            key = k.replace('metadata.', '');
            item.metadata[key] = {
                value: val.join(', '),
                name: mdnames[key],
            }
        } else if (k.startsWith('source')) {
            key = k.replace('source.', '');
            item.source[key] = val.join(', ');
        }


    })

    itemIIP(item);
    return item;
}

const itemIIP = (item) => {
    let iiproute = item.metadata.dc_identifier_other?.value;
    // if (iiproute?.indexOf('assetstore/') >= 0) {
    //     item.iiproute = iiproute;
    // } else
    if (iiproute?.indexOf('/') >= 0) {
        // item.iiproute = 'assetstore/' + iiproute;
        item.iiproute = iiproute;
    } else {
        item.iiproute = iiproute?.match(ROUTE_REGEX);
        let tail = item.iiproute?.shift();
        item.iiproute?.pop();
        item.iiproute?.push(tail);
        item.iiproute?.unshift('assetstore');
        item.iiproute = item.iiproute?.join('/');
    }
    item.iipis = item.source?.iipImageServer;
    item.iipimg = `${item.iipis}?IIIF=${item.iiproute}/info.json`;
    item.iipthumb = `${item.iipis}?FIF=${item.iiproute}&WID=200&HEI=200&CVT=jpeg`;
    item.iipbigthumb = `${item.iipis}?FIF=${item.iiproute}&WID=500&HEI=500&CVT=jpeg`;
}

export const queryJson = ({query, filters, size = 10, from = 0, isSearch = false}) => {
    // filters = filters?.filter(([key, val]) => key != 'query' && key != 'path' && key != 'from' && key != 'index');

    if (!isSearch) {
        // console.log('Random');
        return {
            "query": {
                "function_score": {
                    "boost": "5",
                    "random_score": {},
                    "boost_mode": "multiply"
                }
            },
            "fields": [
                "metadata.dc_title",
                "metadata.dc_identifier_other",
                "source.iipImageServer"
            ],
            "_source": false,
            "from": 0,
            "size": size
        };
    }
    // console.log('Query');
    let q = query ? `((${query}) OR ('* ${query} *') OR (*${query}*))` : '(*)';
    let fl = filters?.map(([key, val]) => `(${key}:(${val.split(' ').join(' AND ')}))`).join(' AND ')
    let f = filters?.length ? `${q ? ' AND ' : ''} ${fl}` : '';
    return {
        "query": {
            "query_string": {
                "query": q + f,
                "fields": mdsearch.map(m => `${m}${m.indexOf('titulo') >= 0 || m.indexOf('title') >= 0 ? '^3' : ''}`)
            }
        },
        "highlight": {
            "fields": mdsearch.reduce((o, m) => {o[`${m}`] = {}; return o}, {}),

        },
        "fields": isSearch ? cardfields : undefined,
        "_source": false,
        "from": from,
        "size": size
    }

}

export const clearString = (str, val = '') => {
    return str?.replace(CLEAR_REGEX, val).replace(SP_REGEX, ' ').normalize("NFD").replace(DIA_REGEX, "");
}

export const getTema = (tema) => {
    return fixedValues.dc_subject.find(t => clearString(t) === clearString(tema)) || tema;
}

export const headers = {
    'Content-Type': 'application/json',
    'Authorization': `ApiKey ${TOKEN}`,
}

export async function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

// Limpia paramétros de búsqueda que no deben de ir en el query para elasticsearch
export const getFilters = (searchParams) => {
    let filters = Array.from(searchParams) || []
    return filters?.filter(([key, val]) => key?.startsWith('metadata.') || key?.startsWith('caso.'));
}

export const checkParams = (searchParams) => {
    return searchParams?.get('query') || getFilters(searchParams).length > 0;
}
